import 'whatwg-fetch';
import _ from 'lodash';
import { notifyError } from 'common/state/notificationState';

const defaultOptions = {
  method: 'GET',
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
  },
};

const api = {
  fetch(dispatch, resourcePath, options = {}) {
    const optionsWithDefaults = _.merge({}, defaultOptions, options);
    const url = `/api/v1/${resourcePath}`;

    return fetch(url, optionsWithDefaults)
      .then(response => {
        if (!response.ok) {


          throw response;
        }
        return response;
      })
      .then(response => Promise.all([response.json(), response]))
      .catch(async response => {
        if (typeof response.json !== 'function') {
          dispatch(notifyError('Unexpected response from server'));
          return {};
        }
        const errors = await response.json();
        const errorMsg = _.flatten(_.values(errors)).join(', ');
        dispatch(notifyError(errorMsg));
        return { errors };
      });
  },
};

export default api;
